const enUs = {
    translations: {
        navbar: {
            detail_one: "Home",
            detail_two: "About",
            detail_three: "Skills",
            detail_four: "Services",
            detail_five: "Certificates",
            detail_six: "Contact",
            detail_seven: "Qualification",
        },

        home: {
            title: "Frontend Developer",
            text: "Hello! I'm Katianne Araújo, a Front-End Developer who loves creating clean, responsive, and easy-to-use interfaces. I work in web development, creating landing pages and web applications as a freelancer and in remote teams. I am currently a collaborator at Ovonne as a Front-End Developer and Technical Leader, contributing to project organization, team guidance, and the application of best practices. I have a degree in Systems Analysis and Development and technical training in Computer Science. I am proactive, constantly learning, and enjoy challenges that allow me to evolve and deliver quality digital solutions. 🚀",
            button: "Talk to me!",
            scrollDown: "Roll down",
        },

        about: {
            title: "About me",
            subtitle: "Introduction",
            text: "I have a degree in Systems Analysis and Development and a technical degree in Computer Science, which gave me a solid foundation in technology from an early age. Throughout my career, I have worked on projects in various areas, such as healthcare, law, education, sales, and services, always seeking to deliver responsive, accessible, and well-structured solutions. Technologies I use: Frontend: HTML5, CSS3, JavaScript, TypeScript, React.js, Next.js, Vue.js Backend & Integrations: Node.js, Prisma, Firebase, REST APIs Tools: Git, GitHub, GitLab, Figma, Stripe, Docker Others: Microservices, Microfrontend, Code Versioning My differential lies in my proactivity and constant willingness to learn. I don't limit myself to what I already know: when a new challenge arises, I seek to learn, apply, and evolve to always deliver the best possible result. I enjoy working in a team, have good communication skills, a sense of responsibility, and am organized with tasks and deadlines. I believe that technology, when applied well, can create incredible experiences and solutions that really make a difference. If you would like to learn about my projects or collaborate on something new, I would be happy to talk!",
        },

        info: {
            title_one: "Experiences",
            subtitle_one: "4 years",
            title_two: "Concluded",
            subtitle_two: "50+ projects",
            title_three: "Learnings",
            subtitle_three: "4+ Technologies",
        },

        skills: {
            title: "Skills",
            subtitle: "My Technical Level",
            front_title: "Frontend Developer",
            back_title: "Backend Developer",
            basic: "Basic",
            inter: "Intermediary",
            advan: "Advanced",
        },

        services: {
            title: "Services",
            subtitle: "What I Offer",
            services_title_one: "Technical Leadership & Optimization",
            services_title_three: "Visual Designer",
            services_title_two: " Web Systems & Integrations",
            button: "See more",
            modal_one: "Creation of web interfaces focused on performance, accessibility, and user experience, following best practices and Figma layouts.",
            p_one: "Landing pages and institutional websites",
            p_two: "Responsive interfaces (mobile first)",
            p_three: "Modern web applications",
            p_four: "Clean and scalable code",
            p_five: "Technologies: HTML, CSS, JavaScript, TypeScript, React, Next.js, Vue.js",
            modal_two: "Development and integration of web systems with APIs, authentication, payments, and databases, ensuring stability and security.",
            p_two_one: "Integration with REST APIs",
            p_two_two: "Authentication and user management",
            p_two_three: "Payments (Stripe)",
            p_two_four: "Integration with Firebase and Prisma",
            p_two_five: "Tecnologias: Node.js, Prisma, Firebase, REST APIs, Stripe",
            modal_three: "Technical support for teams and projects, focusing on best practices, code organization, and continuous improvement.",
            p_three_one: "Task organization and development workflow",
            p_three_two: "Code review and standardization",
            p_three_three: "Performance and accessibility optimization",
            p_three_four: "Mentoring and technical support for the team",
            p_three_five: "Differentials: Best practices, accessibility, versioning with Git, collaborative work.",
        },

        qualification: {
            title: "Qualifications",
            subtitle: "My Personal Journey",
            qualification_title_one: "Education",
            qualification_title_two: "Experiences",
            qualification_subtitle_one: "Computer Tecnician",
            qualification_subtitle_two: "Vocational School",
            qualification_subtitle_three: "Analysis and Systems Development",
            qualification_subtitle_four: "IT Intern",
            qualification_subtitle_five: "Student",
            qualification_subtitle_sixe: "Frontend Developer",
            data_one: "Aug",
            data_two: "May",
            data_three: "Dec",
            data_four: "Jul"
        },

        Certificates: {
            title: "Certificates",
            subtitle: "Qualifications acquired",
            time_one: "Hours",
            title_one: "Advanced applications with Angular",
            title_two: "Career Accelerator with Power BI",
            title_three: "Concepts and best practices with PostgreSQL databases",
            title_five: "Advanced development with JavaScript ES6",
            title_six: "Advanced development in Java",
            title_seven: "Data Structure in Java",
            title_eight: "Advanced Excel",
            title_nine: "Hiring Coders #3 on the Full Stack Training Track",
            title_ten: "Hiring Coders #3 on the VTEX IO, AWS, DevOps and Digital E-commerce Training Trail",
            title_eleven: "Hiring Coders #3 on the Training Track in VTEX IO",
            title_thirteen: "Implementing Collection and Streams with Java",
            title_fourteen: "Introduction to creating websites with HTML5 and CSS3",
            title_fiveteen: "Introduction to Angular 8",
            title_seventeen: "Zero to Code Marathon - IV Edition",
            title_eighteen: "Inverted Marathon",
            title_twenty: "Spring React Week",
            title_twentythree: "Advanced techniques in Angular 8",
        },

        Contact: {
            title: "Contact",
            subtitle: "My contact",
            title_one: "Talk to me",
            title_two: "Write yout Message",
            button_link: "Write me",
            name: "Name",
            input_name: "Insert your name",
            input_email: "Insert your email",
            textarea: "Message",
            button: "Send Message"
        },

        footer: {
            text: "All rights reserved"
        }
    }
}

export default enUs;